// import utils from '@/utils';
export default {
  data() {
    return {
      currentMode: 'view'
    }
  },
  computed: {
    viewMode() {
      return this.currentMode === 'view'
    },
    editMode() {
      return this.currentMode === 'edit'
    }
  },
  methods: {
    changeMode(mode) {
      this.currentMode = mode
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/ViewEditMode.js